import styled, { css } from 'styled-components'

const StyledPageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 10px;
  ${props =>
    props.sticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 999;
    `};
`

export default StyledPageHeader
